<template>
  <div class="photo-page">
    <div class="ui container">
      <div class="page-header m-padded-tb-big">
        <div class="header-wrapper">
          <div class="header-icon">
            <i class="magic icon"></i>
          </div>
          <div class="header-content">
            <h2 class="header-title">照片神器</h2>
            <p class="header-subtitle">AI 证件照 · 景点照片合成，一站式在线生成</p>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          <i class="id card icon"></i>AI 证件照
        </div>
        <IdPhoto />
      </div>

      <div class="section">
        <div class="section-title">
          <i class="camera retro icon"></i>景点合成
        </div>
        <ScenicComposite />
      </div>
    </div>
  </div>
</template>

<script>
import IdPhoto from './IdPhoto'
import ScenicComposite from './ScenicComposite'

export default {
  name: 'PhotoMagic',
  components: {
    IdPhoto,
    ScenicComposite
  }
}
</script>

<style scoped>
.photo-page {
  min-height: 80vh;
  padding-top: 10px;
  padding-bottom: 40px;
  background-color: #f5f5f5;
}

.page-header {
  text-align: center;
  padding: 30px 0;
}

.header-wrapper {
  display: inline-flex;
  align-items: center;
  gap: 16px;
  padding: 20px 40px;
  background: linear-gradient(135deg, #36d1dc 0%, #5b86e5 100%);
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(91, 134, 229, 0.25);
}

.header-icon {
  width: 56px;
  height: 56px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-icon .magic.icon {
  font-size: 28px;
  color: white;
  margin: 0;
}

.header-content {
  text-align: left;
}

.header-title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: white;
  letter-spacing: 1px;
}

.header-subtitle {
  margin: 6px 0 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 300;
}

.section {
  margin-bottom: 20px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 14px;
  padding-left: 12px;
  border-left: 4px solid #5b86e5;
}

.section-title .icon {
  color: #5b86e5;
  margin: 0;
}
</style>
